<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <!--  科研规模年度统计 -->
      <v-flex xs12 sm12 md6 lg4>
        <v-card flat>
          <v-card-text>
            <contract-by-year/>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md6 lg4>
        <v-card flat>
          <v-card-text>
            <fund-by-year/>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md6 lg4>
        <v-card flat>
          <v-card-text>
            <nsfc-by-year/>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <paper-count-by-level-and-index/>
      </v-flex>

      <v-flex xs6 sm6 md3 lg2>
        <v-card flat>
          <v-card-title class="text-xs-center">
            <v-icon medium color="orange darken-2" class="mr-1">fas fa-envelope</v-icon>
            <span class="subheading">知识产权申请</span>
          </v-card-title>
          <property-table uri="/api/inte/report/count/appl/by/type"></property-table>
        </v-card>
      </v-flex>

      <v-flex xs6 sm6 md3 lg2>
        <v-card flat>
          <v-card-title class="text-xs-center">
            <v-icon medium color="yellow darken-2" class="mr-1">fas fa-certificate</v-icon>
            <span class="subheading">知识产权授权</span>
          </v-card-title>
          <property-table uri="/api/inte/report/count/granted/by/type"></property-table>
        </v-card>
      </v-flex>

      <v-flex xs6 sm6 md3 lg2>
        <v-card flat>
          <v-card-title class="text-xs-center">
            <v-icon medium color="blue darken-2" class="mr-1">fas fa-book</v-icon>
            <span class="subheading">论著</span>
          </v-card-title>
          <property-table uri="/api/book/report/count/by/type"/>
        </v-card>
      </v-flex>

      <v-flex xs6 sm6 md3 lg2>
        <v-card flat>
          <v-card-title class="text-xs-center">
            <v-icon medium color="green darken-2" class="mr-1">fas fa-trophy</v-icon>
            <span class="subheading">奖励</span>
          </v-card-title>
          <property-table uri="/api/awar/report/count/by/level"/>
        </v-card>
      </v-flex>

      <v-flex xs6 sm6 md3 lg2>
        <v-card flat>
          <v-card-title class="text-xs-center">
            <v-icon medium color="pink darken-2" class="mr-1">fas fa-building</v-icon>
            <span class="subheading">科研平台</span>
          </v-card-title>
          <property-table uri="/api/proj/report/lab/count/by/type"></property-table>
        </v-card>
      </v-flex>

      <v-flex xs6 sm6 md3 lg2>
        <v-card flat>
          <v-card-title class="text-xs-center">
            <v-icon medium color="green darken-2" class="mr-1">fas fa-users</v-icon>
            <span class="subheading">科研团队</span>
          </v-card-title>
          <property-table uri="/api/proj/report/team/count/by/type"></property-table>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>

  import FundByYear from '../proj/rept/FundByYear'
  import NsfcByYear from '../proj/rept/NsfcByYear'
  import ContractByYear from '../proj/rept/ContractByYear'

  import PaperCountByLevelAndIndex from '../papr/rept/CountByLevelAndIndex'

  import PropertyTable from '../global/PropertyTable'

  export default {
    name: "Index",
    components: {
      ContractByYear,
      FundByYear,
      NsfcByYear,
      PropertyTable,
      PaperCountByLevelAndIndex
    },
    data() {
      return {}
    }
  }
</script>
